module.exports = __webpack_public_path__ + "static/media/pinNie.b25b27ce.png";